import type { ReactNode } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardBody } from '@vnetwork/ui/primitives';
import styles from './EventJobCreate.module.css';

interface FormSectionCardProps {
  title: ReactNode;
  description?: ReactNode;
  /** Right-aligned header slot — e.g. the Switch gating the whole section. */
  actions?: ReactNode;
  /** Section controls. When absent (gated section toggled off) only the header renders. */
  children?: ReactNode;
  className?: string;
}

/**
 * Card-per-section framing for the create forms (canonical wizard idiom):
 * CardHeader = title + description (+ optional gating Switch), CardBody = controls
 * stacked with a consistent --vn-space-4 rhythm.
 */
export function FormSectionCard({ title, description, actions, children, className }: FormSectionCardProps) {
  const hasBody = children !== undefined && children !== null && children !== false;
  return (
    <Card flat className={className ? `${styles.sectionCard} ${className}` : styles.sectionCard}>
      <CardHeader actions={actions} className={hasBody ? undefined : styles.sectionHeaderOnly}>
        <CardTitle>{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
      {hasBody ? <CardBody className={styles.sectionBody}>{children}</CardBody> : null}
    </Card>
  );
}
